<aside class="flex h-full w-[240px] flex-col border-[var(--border-default)] bg-[var(--bg-surface)] px-1 py-6 border-r">
  <nav class="flex-1">
    <div class="space-y-1">
      @for (item of menuItems(); track item.label) {
        @if (item.type === 'separator') {
          <div class="px-3 py-3">
            <span class="text-[11px] font-semibold leading-3 tracking-[0.44px] qbrain-text-tertiary">
              {{ item.label | translate }}
            </span>
          </div>
        } @else {
          <a
            [routerLink]="item.route"
            routerLinkActive="bg-sky-100 text-primary"
            class="flex items-center gap-3 px-2 py-2 text-base font-normal qbrain-text-primary
                  hover:bg-sky-50 hover:text-primary rounded-sm transition-colors duration-200
                  whitespace-nowrap overflow-hidden text-ellipsis"
          >
            @switch(item.icon) {
              @case('chat')  { <img src="assets/icons/chats.svg" [alt]="'navigation.menu.chats' | translate" /> }
              @case('home')  { <img src="assets/icons/campaign.svg" [alt]="'navigation.menu.news' | translate" /> }
              @case('users')  { <img src="assets/icons/users.svg" [alt]="'navigation.menu.users' | translate" /> }
              @case('workspace')  { <img src="assets/icons/workspace.svg" [alt]="'navigation.menu.workspaces' | translate" /> }
              @case('knowledge-base')  { <img src="assets/icons/book.svg" [alt]="'navigation.menu.knowledgeBase' | translate" /> }
              @case('panel')  { <img src="assets/icons/task-line.svg" [alt]="'navigation.menu.requestsPanel' | translate" /> }
              @case('gauge') { <img src="assets/icons/dashboard-3-line.svg" [alt]="'navigation.menu.metrics' | translate" /> }
            }
            <span class="flex-1 overflow-hidden text-ellipsis whitespace-nowrap">
              {{ item.label | translate }}
            </span>
            @if (item.isNew) {
              <span
                class="ml-2 shrink-0 inline-flex items-center rounded-full px-2 py-[2px]
                       bg-[var(--primary-50)] text-[var(--primary-700)] qbrain-text-xs font-semibold"
              >
                {{ 'common.labels.new' | translate }}
              </span>
            }
          </a>
        }
      }
    </div>
  </nav>
</aside>